<form [formGroup]="form">
    <p>Op de hoogte blijven? Dat kan! Via mail en/of SMS trekken we aan de bel, zodra er nieuws is.</p>
    <ins-claim-notification-section>
        <h4>
            Updates via e-mail
            <ins-click-tooltip>Klopt het e-mailadres niet? U kunt dit wijzigen bij Mijn gegevens.</ins-click-tooltip>
        </h4>
        <cyno-field [showSuccess]="false" class="claim-notification-field">
            <cyno-label>Wilt u per e-mail updates over uw lopende schade ontvangen?</cyno-label>
            <cyno-radio formControlName="emailNotificationIndication" [value]="claimNotificationIndicationEnum.Yes">
                Ja
            </cyno-radio>
            <cyno-radio formControlName="emailNotificationIndication" [value]="claimNotificationIndicationEnum.No">
                Nee
            </cyno-radio>
        </cyno-field>
        <ins-claim-notification-data
            label="E-mail:"
            tooltip="Klopt het e-mailadres niet? U kunt dit wijzigen bij Mijn gegevens."
        >
            {{ relation?.primary_email_address?.email_address }}
        </ins-claim-notification-data>
    </ins-claim-notification-section>
    <ins-claim-notification-section [lastChild]="true">
        <h4>
            Updates via SMS
            <ins-click-tooltip>Klopt het telefoonnummer niet? U kunt dit wijzigen bij Mijn gegevens.</ins-click-tooltip>
        </h4>
        <cyno-field [showSuccess]="false" class="claim-notification-field">
            <cyno-label>Wilt u per SMS updates over uw lopende schade ontvangen?</cyno-label>
            <cyno-radio formControlName="smsNotificationIndication" [value]="claimNotificationIndicationEnum.Yes">
                Ja
            </cyno-radio>
            <cyno-radio formControlName="smsNotificationIndication" [value]="claimNotificationIndicationEnum.No">
                Nee
            </cyno-radio>
        </cyno-field>
        <ins-claim-notification-data
            label="SMS:"
            tooltip="Klopt het telefoonnummer niet? U kunt dit wijzigen bij Mijn gegevens."
        >
            {{ relation?.mobile_telephone_number?.telephone_number }}
        </ins-claim-notification-data>
    </ins-claim-notification-section>
</form>
